module.exports = __webpack_public_path__ + "media/apps/gif-ios-12-9fe7ef75.gif";